import context from '@truckdown/components-systems';
import { IUserManager, UserModel, UserStatus, UpdateAdminUserSettingsModel } from "@truckdown/accounts";
import { defineComponent, ref, Ref, computed, onMounted } from "vue";
import { showMessage } from "../../../Utilities/Utilities";

interface IData {
    isLoading: Ref<boolean>,
    userProfile: Ref<UserModel>,
    updateModel: Ref<UpdateAdminUserSettingsModel>
    primaryContact: Ref<boolean>,
    billingContact: Ref<boolean>,
    status: Ref<UserStatus>
};

const getAllowedToRateVendors = function (userProfile: UserModel) {
    var suppressRatings = (userProfile as UserModel).claims.find(c => {
        return c.type == "search_suppress_ratings";
    });

    return (suppressRatings?.value ?? "True") == "True";
}

const getInitialData = function (props: any) {
    var userProfile = props.userProfile as UserModel;

    var update = {
        id: props.userProfile.id,
        isPrimary: props.userProfile.isPrimary,
        isBilling: props.userProfile.isBilling,
        status: userProfile.status,
        suppressRatings: getAllowedToRateVendors(props.userProfile)
    } as UpdateAdminUserSettingsModel;

    return {
        isLoading: ref<boolean>(false),
        userProfile: ref<UserModel>(props.userProfile),
        updateModel: ref < UpdateAdminUserSettingsModel>(update)
    } as IData;
}

const getMethods = function (props: any, data: IData, ctx: any) {
    return {
        getAllowedToRateVendors: function () {
            var suppressRatings = (props.userProfile as UserModel).claims.find(c => {
                return c.type == "search_suppress_ratings";
            });

            return (suppressRatings?.value ?? "False") == "True";
        },
        editAdminSettingsCancelClick: function (): void {
            ctx.emit(userCancelEventName);
        },
        editAdminSettingsSaveClick: async function (): Promise<void> {
            await saveUser(data, props, ctx);
        },
        statusDisplay: function (status: UserStatus): string {
            return UserStatus[status];
        }
    }
}

const saveUser = async function (data: IData, props: any, ctx: any): Promise<void> {
    if (!data.isLoading.value) {
        data.isLoading.value = true;

        try {
            let userManager = await context.getService<IUserManager>('IUserManager');
            var response = await userManager.updateAdminUserSettings(data.updateModel.value);

            if (!response || !response.ok) {
                console.log("Error updating admin user settings: " + response.message);
                showMessage("Error updating admin user settings.", "danger", true, true);
            } else {
                showMessage("Admin User Settings was successfully updated.", "success", true, true);
                ctx.emit(userUpdatedEventName, response.data);
            }
        } catch (err) {
            console.error(err);
        } finally {
            data.isLoading.value = false;
        }
    }
}

const userUpdatedEventName = 'update';
const userCancelEventName = 'cancel';

export default defineComponent({
    props: {
        userProfile: {
            type: Object as () => UserModel,
            required: true
        }
    },
    components: {
    },
    emits: [userUpdatedEventName, userCancelEventName],
    setup: function (props, ctx) {
        let data = getInitialData(props);
        let methods = getMethods(props, data, ctx);
       
        return {
            ...data,
            ...computed,
            ...methods,
            UserStatus
        };
    }
});